const DEFAULT_API_STRING = process.env.REACT_APP_API_BASE || "http://localhost:8021"
const PREFIX = "/api"
const DEFAULT_VERSIONING_STRING = "/v1"

export const baseApi = DEFAULT_API_STRING + PREFIX + DEFAULT_VERSIONING_STRING
